import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { ModalShell } from "./ModalShell";

export function ConfirmModal({
  title,
  message,
  confirmLabel = "Confirm",
  onCancel,
  onConfirm,
}) {
  return (
    <ModalShell icon={<ErrorOutlineIcon />} title={title} onClose={onCancel}>
      <p>{message}</p>
      <div className="modal-actions">
        <button type="button" className="touch-button" onClick={onCancel}>
          Cancel
        </button>
        <button type="button" className="touch-button danger" onClick={onConfirm}>
          {confirmLabel}
        </button>
      </div>
    </ModalShell>
  );
}
